import { CiPhone, CiShop, CiUser } from "react-icons/ci";

import "../style.css"

export function DadosEmpresa({ handleChange, formData, handleDoc, statusConsulta, tipoCliente, gerarLinkDePagamento, loadingCheckout }) {

    return (
        <>
            <div className="input-group slide-up active-field" style={{ animationDelay: '0.6s' }}>
                <label style={{ color: '#9ca3af' }}>Razão Social</label>
                <input type="text" name="nomeEmpresa" value={formData.nomeEmpresa} onChange={handleChange} />
                <span className="input-icon"><CiShop /></span>
            </div>

            <div className="input-group slide-up active-field" style={{ animationDelay: '0.5s' }}>
                <label style={{ color: "#9ca3af" }}>WhatsApp</label>
                <input type="text" name="whatsapp" value={formData.whatsapp} onChange={handleChange} />
                <span className="input-icon"><CiPhone /></span>
            </div>

            {tipoCliente !== 'souCliente' && (
                <>
                    <div className="input-group slide-up active-field" style={{ animationDelay: '0.5s' }}>
                        <label style={{ color: "#9ca3af" }}>Nome</label>
                        <input type="text" name="nome" value={formData.nome} onChange={handleChange} />
                        <span className="input-icon"><CiPhone /></span>
                    </div>

                    <div className="input-group slide-up active-field" style={{ animationDelay: '0.5s' }}>
                        <label style={{ color: "#9ca3af" }}>Email</label>
                        <input type="text" name="email" value={formData.email} onChange={handleChange} />
                        <span className="input-icon"><CiPhone /></span>
                    </div>
                </>
            )}

            <div className="extra-fields slide-up" style={{ borderTop: '1px dashed #ccc', marginTop: '20px', paddingTop: '20px' }}>
                <p style={{ fontSize: '14px', color: '#005a9e', fontWeight: 'bold', marginBottom: '10px' }}>
                    Digite o número do seu documento:
                </p>

                {/* Rádios para Seleção */}
                <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <input
                            type="radio"
                            name="doc"
                            value="cnh"
                            checked={formData.tipoDocumento === 'cnh'}
                            onChange={handleDoc}
                        />
                        CNH
                    </label>

                    {statusConsulta === 'cliente-com-biometria' && (
                        <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <input
                                type="radio"
                                name="doc"
                                value="rg"
                                checked={formData.tipoDocumento === 'rg'}
                                onChange={handleDoc}
                            />
                            RG
                        </label>
                    )}
                </div>

                {/* Campo Dinâmico conforme o Rádio */}
                <div className="input-group active-field">
                    <label style={{ color: "#9ca3af" }}>{formData.tipoDocumento === 'cnh' ? 'Número da CNH' : 'Número do RG'}</label>
                    <input
                        type="text"
                        name="documento"
                        value={formData.documento}
                        onChange={handleChange}
                        placeholder={
                            formData.tipoDocumento === 'cnh'
                                ? 'Digite sua CNH'
                                : 'Digite seu RG'
                        }
                    />
                    <span className="input-icon"><CiUser /></span>
                </div>
            </div>
            <button
                type="button"
                className="btn-submit slide-up"
                style={{ animationDelay: '0.7s' }}
                disabled={loadingCheckout}
                onClick={gerarLinkDePagamento}
            >
                {loadingCheckout ? 'Gerando pagamento...' : 'Continuar'}
            </button>
        </>
    )
}